import { CloudUploadIcon } from 'lucide-react'
import type { DropzoneRootProps } from 'react-dropzone'

interface PageDropOverlayProps {
  rootProps: DropzoneRootProps
  hint: string
}

export const PageDropOverlay = ({ rootProps, hint }: PageDropOverlayProps) => (
  <div
    {...rootProps}
    className="fixed inset-0 z-50 flex items-center justify-center bg-brand/10 backdrop-blur-[1px]"
  >
    <div className="flex flex-col items-center gap-2 rounded-lg border-2 border-dashed border-brand bg-white px-10 py-8 text-center shadow-lg">
      <CloudUploadIcon className="text-brand size-10" />
      <p className="font-medium">Drop files to add them</p>
      {hint && <p className="text-ink-subtle text-xs">{hint}</p>}
    </div>
  </div>
)
